// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Result = require("@rescript/core/src/Core__Result.bs.js");

function makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              baths: baths,
              beds: beds,
              halfBaths: halfBaths,
              livingArea: livingArea,
              lotSize: lotSize
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making singleFamilyAttributes"
          };
  }
}

function makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              baths: baths,
              beds: beds,
              halfBaths: halfBaths,
              livingArea: livingArea,
              lotSize: lotSize
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making condoAttributesInput"
          };
  }
}

function makeLotAttributesInput(lotSize) {
  if (lotSize !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              lotSize: lotSize
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making lotAttributesInput"
          };
  }
}

function makeMultiUnitAttributesInput(numberOfUnits) {
  if (numberOfUnits !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              numberOfUnits: numberOfUnits
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making multiUnitAttributesInput"
          };
  }
}

function make(propertyType, beds, baths, halfBaths, lotSize, livingArea, numberOfUnits) {
  if (propertyType === "Condo") {
    return Core__Result.map(makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea), (function (condo) {
                  return {
                          condo: condo
                        };
                }));
  } else if (propertyType === "Lot") {
    return Core__Result.map(makeLotAttributesInput(lotSize), (function (lot) {
                  return {
                          lot: lot
                        };
                }));
  } else if (propertyType === "MultiUnit") {
    return Core__Result.map(makeMultiUnitAttributesInput(numberOfUnits), (function (multiUnit) {
                  return {
                          multiUnit: multiUnit
                        };
                }));
  } else {
    return Core__Result.map(makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea), (function (singleFamily) {
                  return {
                          singleFamily: singleFamily
                        };
                }));
  }
}

var Schema;

exports.Schema = Schema;
exports.makeSingleFamilyAttributesInput = makeSingleFamilyAttributesInput;
exports.makeCondoAttributesInput = makeCondoAttributesInput;
exports.makeLotAttributesInput = makeLotAttributesInput;
exports.makeMultiUnitAttributesInput = makeMultiUnitAttributesInput;
exports.make = make;
/* No side effect */
